import React, { Component } from 'react';
import './BedroomsFilter.css';
import CheckboxFilter from './CheckboxFilter';
import MenuType from '../enums/MenuType';
import Option from '../choices/Option';
import SubMenuHeader from './SubMenuHeader';
import ClickedOffManager from '../ui_core/ClickedOffManager';
export default class BedroomsFilter extends Component {
	constructor(props){
		super(props);
		const {bedroomsFilterSettings, onSelectedOptionsChange}=props;
		this._callbackSelectedOptionsChange=onSelectedOptionsChange;
		this._checkboxFilter=React.createRef();
		this._subMenuHeader = React.createRef();
		this._element = React.createRef();
		this._options = [];
		this.load = this.load.bind(this);
		this._updateOptions = this._updateOptions.bind(this);
		this._iMenuManager  = null;
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this.filterPlots = this.filterPlots.bind(this);
		this.clear = this.clear.bind(this);
		this._clickedOffManager = new ClickedOffManager({elementRef:this._element, hide:this.hide});
		this.state = {options:[], visible:false};
	}
	setFromWhatAreYouLookingForViewModel(whatAreYouLookingForViewModel){
		const nBedrooms = whatAreYouLookingForViewModel.nBedrooms;
		if(nBedrooms===undefined||nBedrooms===null)return;
		const checkboxOption = this._checkboxFilter.current.getCheckboxOptions()
			.map(checkboxOption=>checkboxOption.ref.current)
			.forEach(checkboxOption=>{
				const value= checkboxOption.value;
				checkboxOption.isChecked = value===nBedrooms;
			});
		this._callbackSelectedOptionsChange();
	}
	show(callbackClose){
		this.setState({visible:true});
		this._clickedOffManager.register();
		this._iMenuManager.showMe(this);
	}
	hide(){
		this._clickedOffManager.dispose();
		this.setState({visible:false});
		this._iMenuManager.close();
	}
	filterPlots(plotsArray){
		const nBedroomssToShow = this._checkboxFilter.current.getCheckedValues();
		if(nBedroomssToShow.length<1)return plotsArray;
		return plotsArray.filter(plot=>nBedroomssToShow.indexOf(plot.nBedrooms)>=0);
	}
	clear(){
		this._checkboxFilter.current.clear();
	}
	setIMenuManager(value){
		this._iMenuManager = value;
		this._subMenuHeader.current.setIMenuManager(value);
	}
	get menuType(){
		return MenuType.BEDROOMS_FILTER;
	}
	get isApplied(){
		return this._checkboxFilter.current.isApplied;
	}
	load(plotsArray){
		const nBedroomssForPlots = [];
		for(var i=0; i<plotsArray.length; i++){
			const plot = plotsArray[i];
			if(nBedroomssForPlots.indexOf(plot.nBedrooms)<0)
				nBedroomssForPlots.push(plot.nBedrooms);
		}
		nBedroomssForPlots.sort();
		this._updateOptions(nBedroomssForPlots);
	}
	_updateOptions(nBedroomssForPlots){
		const options = nBedroomssForPlots.map((nBedrooms)=>new Option({text:`${nBedrooms} ${(nBedrooms>1?"bedrooms":"bedroom")}`,
			value:nBedrooms}));
		this._checkboxFilter.current.setOptions(options);
	}
	render() {
		let className = "bedrooms-filter menu";
		if(this.state.visible)
			className+= " visible";
		return (<div className={className} ref={this._element}>
				<SubMenuHeader ref={this._subMenuHeader} title="Bedrooms"></SubMenuHeader>
				<CheckboxFilter ref = {this._checkboxFilter} options={this._options} onSelectionChange={this._callbackSelectedOptionsChange}></CheckboxFilter></div>)
	}
}
